import {
  ActivityFeedDraftTypeEnum,
  ActivityFeedStatusEnum,
  IActivityFeedDraftComment,
  IActivityFeedDraftPost,
  ISocketComment,
  ISocketPost,
  TActivityFeedEvent,
  TActivityFeedPosts,
} from './';

export const convertSearchComments = (posts: TActivityFeedPosts) => {
  const flatComments = posts.items.flatMap((item) => item.data.comments);
  const comments = flatComments.map((comment) => {
    return {
      ...comment,
      replies: comment?.replies || [],
      createdAt: comment?.createdAt || new Date().toISOString(),
    };
  });

  return comments;
};

export const convertToPostDraft = (
  eventData: ISocketPost,
  eventProjectId: number
): IActivityFeedDraftPost => {
  const { id, status, createdAt, postVisibility } = eventData;
  const { mentions, activityFeedItemId, content, phases, phaseItems, profile, uploads } =
    eventData.data;

  return {
    id,
    projectId: eventProjectId,
    status,
    createdAt,
    type: ActivityFeedDraftTypeEnum.POST,
    data: {
      mentions,
      id,
      activityFeedItemId,
      content,
      postVisibility,
      phases,
      phaseItems,
      profileId: profile.id,
      uploads,
      profile,
    },
  };
};

export const convertToCommentDraft = (
  eventData: ISocketComment,
  eventProjectId: number
): IActivityFeedDraftComment => {
  const {
    createdAt,
    id,
    status,
    activityFeedItemId,
    content,
    mentions,
    profile,
    postId,
    replyToCommentId = null,
    rootCommentId = null,
    uploads,
  } = eventData;

  return {
    createdAt,
    data: {
      activityFeedItemId,
      content,
      createdAt,
      id,
      mentions,
      postId,
      profile,
      profileId: profile.id,
      replyToCommentId,
      rootCommentId,
      uploads,
    },
    id: activityFeedItemId,
    projectId: eventProjectId,
    status,
    type: ActivityFeedDraftTypeEnum.COMMENT,
  };
};

export const isStatusEqualToDraft = (status: ActivityFeedStatusEnum) => {
  return status === ActivityFeedStatusEnum.DRAFT;
};

export const isDraft = (eventData: TActivityFeedEvent) => {
  if (
    'data' in eventData &&
    'status' in eventData.data &&
    eventData.data.status === ActivityFeedStatusEnum.DRAFT
  ) {
    return true;
  }

  if (
    'data' in eventData &&
    'activityFeedItemIds' in eventData.data &&
    Array.isArray(eventData.data.activityFeedItemIds) &&
    eventData.data.activityFeedItemIds[0]?.status === ActivityFeedStatusEnum.DRAFT
  ) {
    return true;
  }

  return false;
};
